import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  ToolbarButton,
  ToolbarButtonGroup,
  ToolbarSeparator,
} from "@prismicio/editor-ui"
import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Editor } from "@tiptap/core"

import { createRunCommandsFn } from "../../models/MenuItems"
import type { Modal } from "../BubbleMenu"

interface LinkItemsProps {
  editor: Editor
  setModal: (modal: Modal) => void
}

export function LinkItems(props: LinkItemsProps) {
  const {
    disabled,
    showWebLinkModal,
    showDocumentsLinkModal,
    showMediaLinkModal,
  } = useLinkItems(props)

  return (
    <>
      <ToolbarSeparator />
      <ToolbarButtonGroup density="compact">
        <ToolbarButton
          disabled={disabled}
          key={RichTextNodeType.hyperlink}
          startIcon="link"
          onClick={showWebLinkModal}
        />
        <DropdownMenu>
          <DropdownMenuTrigger>
            <ToolbarButton startIcon="arrowDropDown" />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" asPortal={false}>
            <DropdownMenuItem
              startIcon={<Icon name="public" />}
              onSelect={showWebLinkModal}
            >
              Link to web page
            </DropdownMenuItem>
            <DropdownMenuItem
              startIcon={<Icon name="description" />}
              onSelect={showDocumentsLinkModal}
            >
              Link to document
            </DropdownMenuItem>
            <DropdownMenuItem
              startIcon={<Icon name="image" />}
              onSelect={showMediaLinkModal}
            >
              Link to media
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </ToolbarButtonGroup>
    </>
  )
}

function useLinkItems(props: LinkItemsProps) {
  const { editor, setModal } = props

  function showWebLinkModal() {
    setModal("webLink")
  }

  function showDocumentsLinkModal() {
    setModal("documentLink")
  }

  function showMediaLinkModal() {
    setModal("mediaLink")
  }

  const disabled = !createRunCommandsFn((commands) =>
    commands.setWebLink({ href: "" }),
  )(editor, { can: true })

  return {
    disabled,
    showWebLinkModal,
    showDocumentsLinkModal,
    showMediaLinkModal,
  }
}
